// Sticky Add to Cart Button
class StickyAddToCart {
  constructor() {
    this.init();
  }

  init() {
    const productForm = document.querySelector('.product-form');
    const addToCartButton = document.querySelector('#ProductSubmitButton-template--main');
    
    if (!productForm || !addToCartButton) return;

    // Create sticky button container
    this.createStickyButton(addToCartButton);
    
    // Add scroll listener
    this.setupScrollListener(addToCartButton);
    
    // Add checkout redirect functionality
    this.setupCheckoutRedirect(productForm);
  }

  createStickyButton(originalButton) {
    const stickyContainer = document.createElement('div');
    stickyContainer.className = 'product-form__submit-sticky';
    stickyContainer.id = 'sticky-cart-button';
    
    const stickyButton = originalButton.cloneNode(true);
    stickyButton.id = 'ProductSubmitButton-sticky';
    
    stickyContainer.appendChild(stickyButton);
    document.body.appendChild(stickyContainer);
    
    // Sync button states
    this.syncButtonStates(originalButton, stickyButton);
  }

  setupScrollListener(originalButton) {
    const stickyContainer = document.getElementById('sticky-cart-button');
    if (!stickyContainer) return;

    let lastScrollTop = 0;
    
    window.addEventListener('scroll', () => {
      const buttonRect = originalButton.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const isScrollingDown = scrollTop > lastScrollTop;
      
      // Show sticky button when original button is out of view and scrolling down
      if (buttonRect.bottom < 0 && isScrollingDown) {
        stickyContainer.classList.add('is-visible');
      } else {
        stickyContainer.classList.remove('is-visible');
      }
      
      lastScrollTop = scrollTop;
    });
  }

  syncButtonStates(originalButton, stickyButton) {
    // Sync disabled state
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'disabled') {
          if (originalButton.disabled) {
            stickyButton.disabled = true;
          } else {
            stickyButton.disabled = false;
          }
        }
      });
    });

    observer.observe(originalButton, { attributes: true });
  }

  setupCheckoutRedirect(productForm) {
    // Redirect to checkout after adding to cart
    productForm.addEventListener('submit', (e) => {
      const form = e.target;
      
      // Only intercept if it's the add-to-cart form
      if (form.getAttribute('data-type') === 'add-to-cart-form') {
        e.preventDefault();
        
        const formData = new FormData(form);
        
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(data => {
          // Redirect to checkout page
          window.location.href = '/checkout';
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          // If there's an error, submit the form normally
          form.submit();
        });
      }
    });
    
    // Also handle sticky button clicks
    const stickyButton = document.getElementById('ProductSubmitButton-sticky');
    if (stickyButton) {
      stickyButton.addEventListener('click', (e) => {
        e.preventDefault();
        // Trigger the original form submission
        productForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new StickyAddToCart();
  });
} else {
  new StickyAddToCart();
}
